import api from "../../../components/axiosComp";
import axios from "axios"; 

export const presignUpload = async ({ folder, contentType, originalName, maxSizeBytes }) => {
  const { data } = await api.post("/api/uploads/presign", {
    folder,
    contentType,
    originalName,
    maxSizeBytes,
  });
  return data; // { url, fields, key, publicUrl, expiresIn, maxSize }
};

export const uploadFileToS3 = async ({ presign, file, onProgress }) => {
  const s3Client = axios.create();

  const resp = await s3Client.put(presign.url || presign.uploadUrl, file, {
    headers: { "Content-Type": file.type },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) {
        onProgress(Math.round((evt.loaded / evt.total) * 100));
      }
    },
  });

  if (![200, 201, 204].includes(resp?.status)) {
    throw new Error("S3 upload failed");
  }

  return { key: presign.key || presign.filePath, publicUrl: presign.publicUrl };
};


// LIST
export const listGames = async (params = {}) => {
  const { data } = await api.get("/api/superAdmin/games", { params });
  // Accept either {games:[...]} or [...]
  return Array.isArray(data?.games) ? data.games : data || [];
};


// CREATE
export const createGame = async (payload) => {
  const { data } = await api.post("/api/superAdmin/games", payload);
  return data;
};

// UPDATE
export const updateGame = async (id, payload) => {
  const safeId = id || payload?._id || payload?.id;
  const { data } = await api.put(`/api/superAdmin/games/${safeId}`, payload);
  return data;
};

// DELETE
export const deleteGame = async (id) => {
  if (!id) throw new Error("Missing game id");
  const { data } = await api.delete(`/api/superAdmin/games/${id}`);
  return data;
};
